const API_ROOTT = 'http://localhost:3018';

const API_ROOT = 'https://app-node.talkmartech.com:3018';
const webPath = 'https://talkmartech.com'
// const webPath = 'https://talkmartech.ondotmail.com'


export { API_ROOT,API_ROOTT, webPath };